import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { obtenerMiPerfil } from './api/perfil';
import { ROLES } from './roles';

// ─────────────────────────────────────────────────────────────
//  useUserRole
//
//  Retorna:
//    user   → objeto Firebase Auth (o null)
//    rol    → 'basico' | 'intermedio' | 'completo' | null
//    loading → true mientras verifica auth + Firestore
//
//  Uso:
//    const { user, rol, loading } = useUserRole();
// ─────────────────────────────────────────────────────────────

export function useUserRole() {
    const [user, setUser] = useState(undefined); // undefined = aún cargando
    const [rol, setRol] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (u) => {
            setUser(u ?? null);

            if (!u) {
                setRol(null);
                setLoading(false);
                return;
            }

            try {
                const perfil = await obtenerMiPerfil();
                // Validar que sea un rol conocido, si no → basico por defecto
                const rolGuardado = perfil?.role;
                const rolValido = Object.values(ROLES).includes(rolGuardado)
                    ? rolGuardado
                    : ROLES.BASICO;
                setRol(rolValido);
            } catch (e) {
                console.error('useUserRole: error leyendo perfil', e);
                setRol(ROLES.BASICO); // fallback seguro
            } finally {
                setLoading(false);
            }
        });

        return () => unsub();
    }, []);

    return { user, rol, loading };
}